import { Component } from '@angular/core';

import { RecaptchaV2BaseComponent } from './recaptchaV2-base';

@Component({
	selector: 'formly-field-recaptcha',
	template: `
		<re-captcha
			[class]="props['noMargin'] ? 'm-0' : 'my-4'"
			[errorMode]="props['errorMode']"
			[formControl]="formControl"
			[siteKey]="props['siteKey']"
			[size]="props['size']"
			(error)="onError($event)"
			class="block"
		/>
	`,
	standalone: false,
})
export class RecaptchaV2Component extends RecaptchaV2BaseComponent {}
